import React, { useEffect, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { isLoggedIn, notAuthorized } from "../../../api/AuthService"
import { exceptAllTabs } from "../../../constant/Constants"
import ReportSubmit from "./ReportSubmit"
import textValidation from "./textValidation"

const selectedCheckboxes = new Set()
function PartAndSpec(props) {
   const [data, setData] = useState({
      reportName: props.reportName,
      expandProductBom: false,
      includeProductBom: false,
      includePackageBom: false,
      latestReleseInput: true,
      includeHyperlink: false,
      allTabs: false,
      attributes: false,
      alternate: false,
      approve: false,
      batteryRollUp: false,
      billOfMaterials: false,
      ebomWnD: false,
      extendedAttributes:false,
      fopFormulaIngredient: false,
      fopViewSubstitutes: false,
      gpsAssesments: false,
      marketClearance: false,
      marketOfSale: false,
      materialsAndComposition: false,
      mepSepCertifications: false,
      mepSepCompEqts: false,
      notes: false,
      partCertifications: false,
      partComponentEquivalents: false,
      performanceCharacteristics: false,
      plants: false,
      producingFormula: false,
      sapBomAsFed: false,
      specsAndDocs: false,

      weightsAndDimensions: false,
      pgDSMCharacteristicsLPD: false,
      pgDSMChemicalandPhysicaProperties: false,
      pgDSMDGClassification: false,
      pgDSMDesignParameter: false,
      pgDSMIPandExportControl: false,
      pgDSMSubstitutePartsIn: false,
      pgDSMSustainability: false,
      pgDSMIncludeMaterialCompositionfromComponentEquivalents: false,
      stabilityDocument:false,
      MOSComponentDetails:false,
      partName: "",
      changeAction: "",
      reportCustomName: "",
      template: "",
      fileData: "",
   })

   const [alertMessage, setMessage] = useState("")
   const [success, setSuccess] = useState(false)
   const [blinkSearch, setBlinkSearch] = useState("reportOptions")

   const handleValidation = (code, msg) => {
      if (code === 999) {
         setSuccess(false)
         setMessage(
            "Please enter Part Names/Change Actions OR upload an Input File to request a report."
         )
         setBlinkSearch("highlightFields")
      } else if (code === 997) {
         setMessage("Please select atleast one tab")
      } else if (code === 200) {
         setSuccess(true)
         selectedCheckboxes.clear()
         setMessage(
            "Your Report will be processed in the background and will complete shortly. Please refresh the screen after few minutes"
         )
      } else if (code === 422 || code === 429 || code === 417 || code === 501) {
         setSuccess(false)
         setMessage(msg)
      } else if (code === 401) {
         notAuthorized(props.navigate)
      } else if (code === 423) {
         setSuccess(false)
         setMessage(
            "The maximum number of In process report requests (5) has been reached. Please submit another report later."
         )
      } else {
         setSuccess(false)
         setMessage("Report submission failed. Please contact SpecReaderExt.im@pg.com for help.")
      }
   }
   const enable_billOfMaterials = () => {
      document.getElementById("billOfMaterials_1").disabled = false
   }
   const disable_billOfMaterials = () => {
      document.getElementById("billOfMaterials_1").disabled = true
   }
   const enable_partComponentEquivalents = () => {
      document.getElementById("partComponentEquivalents_1").disabled = false
   }

   const disable_partComponentEquivalents = () => {
      document.getElementById("partComponentEquivalents_1").disabled = true
   }
   const handleInputChange = (e) => {
      setMessage("")
      const target = e.target
      const checked = target.checked
      const name = target.name
      setData((data) => ({
         ...data,
         [name]: checked,
      }))
      if (name === "includePackageBom" && data.includePackageBom === true) {
         setData((prevData) => ({
            ...prevData,
            includePackageBom: !checked,

            billOfMaterials: false,
         }))

         selectedCheckboxes.add("billOfMaterials")
         enable_billOfMaterials()
      }
      if (name === "includePackageBom" && data.includePackageBom === false) {
         setData((prevData) => ({
            ...prevData,
            includePackageBom: checked,

            billOfMaterials: true,
         }))
         selectedCheckboxes.add("billOfMaterials")
         disable_billOfMaterials()
      } else {
         setData((prevData) => ({
            ...prevData,
            [name]: checked,
         }))
      }
      if (
         name === "pgDSMIncludeMaterialCompositionfromComponentEquivalents" &&
         data.pgDSMIncludeMaterialCompositionfromComponentEquivalents === true
      ) {
         setData((prevData) => ({
            ...prevData,
            pgDSMIncludeMaterialCompositionfromComponentEquivalents: !checked,

            partComponentEquivalents: false,
         }))
         selectedCheckboxes.add("partComponentEquivalents")
         enable_partComponentEquivalents()
      }
      if (
         name === "pgDSMIncludeMaterialCompositionfromComponentEquivalents" &&
         data.pgDSMIncludeMaterialCompositionfromComponentEquivalents === false
      ) {
         setData((prevData) => ({
            ...prevData,
            pgDSMIncludeMaterialCompositionfromComponentEquivalents: checked,

            partComponentEquivalents: true,
         }))
         selectedCheckboxes.add("partComponentEquivalents")
         disable_partComponentEquivalents()
      } else {
         setData((prevData) => ({
            ...prevData,
            [name]: checked,
         }))
      }
      if (name === "includeProductBom" && data.includeProductBom === true) {
         setData((prevData) => ({
            ...prevData,

            includeProductBom: !checked,
            billOfMaterials: false,
         }))
         selectedCheckboxes.add("billOfMaterials")
         enable_billOfMaterials()
      }

      if (name === "includeProductBom" && data.includeProductBom === false) {
         setData((prevData) => ({
            ...prevData,

            includeProductBom: checked,
            billOfMaterials: true,
         }))
         selectedCheckboxes.add("billOfMaterials")
         disable_billOfMaterials()
      } else {
         setData((prevData) => ({
            ...prevData,
            [name]: checked,
         }))
      }
   }

   const handleCheckbox = (e) => {
      setMessage("")
      const target = e.target
      const checked = target.checked
      const name = target.name
      if (name !== "allTabs") {
         setData((data) => ({
            ...data,
            [name]: checked,
            allTabs: false,
         }))
         selectedCheckboxes.delete("allTabs")

         if (!exceptAllTabs.includes(name)) {
            if (checked) {
               if (!selectedCheckboxes.has(name)) {
                  selectedCheckboxes.add(name)
               }
            } else {
               selectedCheckboxes.delete(name)
            }
         }
      } else {
         for (const key of Object.keys(data)) {
            if (!exceptAllTabs.includes(key)) {
               setData((data) => ({
                  ...data,
                  [key]: checked,
               }))
               if (checked) {
                  if (!selectedCheckboxes.has(key)) {
                     selectedCheckboxes.add(key)
                  }
               } else {
                  selectedCheckboxes.clear()
               }
            }
         }
      }
   }

   const handleTemplateTabs = (boxdata) => {
      let allTabsChecked = true
      for (const key of Object.keys(boxdata)) {
         if (!exceptAllTabs.includes(key)) {
            if (boxdata[key]) {
               if (!selectedCheckboxes.has(key)) {
                  selectedCheckboxes.add(key)
               }
            } else {
               allTabsChecked = false
               selectedCheckboxes.delete(key)
            }

            if (allTabsChecked) {
               setData((data) => ({
                  ...data,
                  allTabs: true,
               }))
            } else {
               setData((data) => ({
                  ...data,
                  allTabs: false,
               }))
            }
         }
      }
   }

   const handleTextChange = (e) => {
      e.preventDefault()
      setBlinkSearch("reportOptions")
      setMessage("")
      const textVal = textValidation(e.target.value, e.target.name)
      if (textVal.props.children || e.target.value === "") {
         const { name, value } = e.target
         setData((data) => ({
            ...data,
            [name]: value,
         }))
      }
   }

   const clearMsg = () => {
      setMessage("")
   }

   const handleClearItems = () => {
      document.getElementById("view").value = "0"
      props.clearItem()
   }

   const fileValidation = (e) => {
      e.preventDefault()
      const filePath = e.target.value
      var allowedExtensions = /(\.txt)$/i

      if (!allowedExtensions.exec(filePath)) {
         alert("Invalid file type. Please upload a text file.")
         e.target.value = ""
         setData((data) => ({
            ...data,
            fileData: "",
         }))
         return false
      }
      const reader = new FileReader()
      reader.onload = async (e) => {
         const text = e.target.result
         const removeNewLine = text.replace(/[\n]+/g, ",")
         const formatedText = removeNewLine.replace(/[\t]/g, " ")
         const textOnly = formatedText.replace(/[^a-zA-Z0-9 ,-]/g, "")
         setData((data) => ({
            ...data,
            fileData: textOnly,
         }))
      }
      reader.readAsText(e.target.files[0])
   }

   const handleClearFile = (e) => {
      e.preventDefault()
      var file = document.getElementById("file")
      file.value = ""
      setData((data) => ({
         ...data,
         fileData: "",
      }))
   }

   useEffect(() => {
      if (!isLoggedIn()) {
         props.navigate("/")
      } else {
         setData((data) => ({
            ...data,
            partName: props.templateData.partName ? props.templateData.partName : "",
            changeAction: props.templateData.changeAction
               ? props.templateData.changeAction
               : "",
            reportCustomName: props.templateData.reportCustomName
               ? props.templateData.reportCustomName
               : "",
            expandProductBom: props.templateData.expandProductBom
               ? props.templateData.expandProductBom
               : false,
            includeProductBom: props.templateData.includeProductBom
               ? props.templateData.includeProductBom
               : false,
            includePackageBom: props.templateData.includePackageBom
               ? props.templateData.includePackageBom
               : false,
            includeHyperlink: props.templateData.includeHyperlink
               ? props.templateData.includeHyperlink
               : false,
            attributes: props.templateData.attributes
               ? props.templateData.attributes
               : false,
            alternate: props.templateData.alternate
               ? props.templateData.alternate
               : false,
            approve: props.templateData.approve ? props.templateData.approve : false,
            batteryRollUp: props.templateData.batteryRollUp
               ? props.templateData.batteryRollUp
               : false,
            billOfMaterials: props.templateData.billOfMaterials
               ? props.templateData.billOfMaterials
               : false,
            ebomWnD: props.templateData.ebomWnD ? props.templateData.ebomWnD : false,
            extendedAttributes: props.templateData.extendedAttributes ? props.templateData.extendedAttributes : false,
            fopFormulaIngredient: props.templateData.fopFormulaIngredient
               ? props.templateData.fopFormulaIngredient
               : false,
            fopViewSubstitutes: props.templateData.fopViewSubstitutes
               ? props.templateData.fopViewSubstitutes
               : false,
            gpsAssesments: props.templateData.gpsAssesments
               ? props.templateData.gpsAssesments
               : false,
            marketClearance: props.templateData.marketClearance
               ? props.templateData.marketClearance
               : false,
            marketOfSale: props.templateData.marketOfSale
               ? props.templateData.marketOfSale
               : false,
            materialsAndComposition: props.templateData.materialsAndComposition
               ? props.templateData.materialsAndComposition
               : false,
            mepSepCertifications: props.templateData.mepSepCertifications
               ? props.templateData.mepSepCertifications
               : false,
            mepSepCompEqts: props.templateData.mepSepCompEqts
               ? props.templateData.mepSepCompEqts
               : false,
            notes: props.templateData.notes ? props.templateData.notes : false,
            partCertifications: props.templateData.partCertifications
               ? props.templateData.partCertifications
               : false,
            partComponentEquivalents: props.templateData.partComponentEquivalents
               ? props.templateData.partComponentEquivalents
               : false,
            performanceCharacteristics: props.templateData.performanceCharacteristics
               ? props.templateData.performanceCharacteristics
               : false,
            plants: props.templateData.plants ? props.templateData.plants : false,
            producingFormula: props.templateData.producingFormula
               ? props.templateData.producingFormula
               : false,
            sapBomAsFed: props.templateData.sapBomAsFed
               ? props.templateData.sapBomAsFed
               : false,
            specsAndDocs: props.templateData.specsAndDocs
               ? props.templateData.specsAndDocs
               : false,

            weightsAndDimensions: props.templateData.weightsAndDimensions
               ? props.templateData.weightsAndDimensions
               : false,
            pgDSMChemicalandPhysicaProperties: props.templateData
               .pgDSMChemicalandPhysicaProperties
               ? props.templateData.pgDSMChemicalandPhysicaProperties
               : false,
            pgDSMCharacteristicsLPD: props.templateData.pgDSMCharacteristicsLPD
               ? props.templateData.pgDSMCharacteristicsLPD
               : false,
            pgDSMDGClassification: props.templateData.pgDSMDGClassification
               ? props.templateData.pgDSMDGClassification
               : false,
            pgDSMDesignParameter: props.templateData.pgDSMDesignParameter
               ? props.templateData.pgDSMDesignParameter
               : false,
            pgDSMIPandExportControl: props.templateData.pgDSMIPandExportControl
               ? props.templateData.pgDSMIPandExportControl
               : false,
            pgDSMSubstitutePartsIn: props.templateData.pgDSMSubstitutePartsIn
               ? props.templateData.pgDSMSubstitutePartsIn
               : false,
            pgDSMSustainability: props.templateData.pgDSMSustainability
               ? props.templateData.pgDSMSustainability
               : false,
            pgDSMIncludeMaterialCompositionfromComponentEquivalents: props.templateData
               .pgDSMIncludeMaterialCompositionfromComponentEquivalents
               ? props.templateData
                    .pgDSMIncludeMaterialCompositionfromComponentEquivalents
               : false,
               stabilityDocument: props.templateData.stabilityDocument
               ? props.templateData.stabilityDocument
               : false,
               MOSComponentDetails: props.templateData.MOSComponentDetails
               ? props.templateData.MOSComponentDetails
               : false
         }))
         handleTemplateTabs(props.templateData)
      }
   }, [props.templateData])

   return (
      <React.Fragment>
         <Row className="mb-3" id="expandProductBom">
            <Col sm="5" md="5">
               <span className="reportLabels">Expand Product BOM</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="expandProductBom"
                  onChange={handleInputChange}
                  checked={data.expandProductBom}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="includeProductBom">
            <Col sm="5" md="5">
               <span className="reportLabels">Include Product BOM Report For FOP on FPP/FPC</span>
            </Col>

            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="includeProductBom"
                  onChange={handleInputChange}
                  checked={data.includeProductBom}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="includePackageBom">
            <Col sm="5" md="5">
               <span className="reportLabels">Include Packaging BOM Report</span>
            </Col>

            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="includePackageBom"
                  onChange={handleInputChange}
                  checked={data.includePackageBom}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pgDSMIncludeMaterialCompositionfromComponentEquivalents">
            <Col sm="5" md="5">
               <span className="reportLabels">Include Material Composition from Component Equivalents</span>
            </Col>

            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMIncludeMaterialCompositionfromComponentEquivalents"
                  onChange={handleInputChange}
                  checked={data.pgDSMIncludeMaterialCompositionfromComponentEquivalents}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="latestReleseInput">
            <Col sm="5" md="5">
               <span className="reportLabels">Latest Release Parts Only (Spec Reader only displays Released Parts)</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check type="checkbox" checked={true} disabled />
            </Col>
         </Row>
         <Row className="mb-3" id="includeHyperlink">
            <Col sm="5" md="5">
               <span className="reportLabels">Include Hyperlink</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="includeHyperlink"
                  onChange={handleInputChange}
                  checked={data.includeHyperlink}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pdfFormlabel">
            <Col sm="11" md="11">
               <span className="reportLabels">
                  <b>
                     Select Tabs/Worksheets needed in the report.
                     <br></br>
                     PLEASE NOTE: Selecting ALL TABS will result in longer processing time.
                  </b>
               </span>
            </Col>
         </Row>
         <Row className="mb-3" id="allTabs">
            <Col sm="5" md="5">
               <span className="reportLabels">ALL TABS</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="allTabs"
                  onChange={handleCheckbox}
                  checked={data.allTabs}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="attributes">
            <Col sm="5" md="5">
               <span className="reportLabels">Attributes</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="attributes"
                  onChange={handleCheckbox}
                  checked={data.attributes}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="alternate">
            <Col sm="5" md="5">
               <span className="reportLabels">Alternate</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="alternate"
                  onChange={handleCheckbox}
                  checked={data.alternate}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="approve">
            <Col sm="5" md="5">
               <span className="reportLabels">Approve</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="approve"
                  onChange={handleCheckbox}
                  checked={data.approve}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="batteryRollUp">
            <Col sm="5" md="5">
               <span className="reportLabels">Battery Roll-Up</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="batteryRollUp"
                  onChange={handleCheckbox}
                  checked={data.batteryRollUp}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="billOfMaterials">
            <Col sm="5" md="5">
               <span className="reportLabels">Bill of Materials</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  id="billOfMaterials_1"
                  name="billOfMaterials"
                  onChange={handleCheckbox}
                  checked={data.billOfMaterials}
               />
            </Col>
         </Row>

         <Row className="mb-3" id="pgDSMCharacteristicsLPD">
            <Col sm="5" md="5">
               <span className="reportLabels">Characteristics - LPD</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMCharacteristicsLPD"
                  onChange={handleCheckbox}
                  checked={data.pgDSMCharacteristicsLPD}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pgDSMChemicalandPhysicaProperties">
            <Col sm="5" md="5">
               <span className="reportLabels">Chemical and Physical Properties</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMChemicalandPhysicaProperties"
                  onChange={handleCheckbox}
                  checked={data.pgDSMChemicalandPhysicaProperties}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pgDSMDesignParameter">
            <Col sm="5" md="5">
               <span className="reportLabels">Design Parameter</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMDesignParameter"
                  onChange={handleCheckbox}
                  checked={data.pgDSMDesignParameter}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pgDSMDGClassification">
            <Col sm="5" md="5">
               <span className="reportLabels">DG Classification</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMDGClassification"
                  onChange={handleCheckbox}
                  checked={data.pgDSMDGClassification}
               />
            </Col>
         </Row>
         
         <Row className="mb-3" id="ebomWnD">
            <Col sm="5" md="5">
               <span className="reportLabels">EBOM W and D</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="ebomWnD"
                  onChange={handleCheckbox}
                  checked={data.ebomWnD}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="extendedAttributes">
            <Col sm="5" md="5">
               <span className="reportLabels">Extended Attributes</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="extendedAttributes"
                  onChange={handleCheckbox}
                  checked={data.extendedAttributes}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="fopFormulaIngredient">
            <Col sm="5" md="5">
               <span className="reportLabels">FOP-Formula Ingredient</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="fopFormulaIngredient"
                  onChange={handleCheckbox}
                  checked={data.fopFormulaIngredient}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="fopViewSubstitutes">
            <Col sm="5" md="5">
               <span className="reportLabels">FOP-View Substitutes</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="fopViewSubstitutes"
                  onChange={handleCheckbox}
                  checked={data.fopViewSubstitutes}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="gpsAssesments">
            <Col sm="5" md="5">
               <span className="reportLabels">GPS Assesments</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="gpsAssesments"
                  onChange={handleCheckbox}
                  checked={data.gpsAssesments}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pgDSMIPandExportControl">
            <Col sm="5" md="5">
               <span className="reportLabels">IP and Export Control</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMIPandExportControl"
                  onChange={handleCheckbox}
                  checked={data.pgDSMIPandExportControl}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="marketClearance">
            <Col sm="5" md="5">
               <span className="reportLabels">Market Clearance</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="marketClearance"
                  onChange={handleCheckbox}
                  checked={data.marketClearance}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="marketOfSale">
            <Col sm="5" md="5">
               <span className="reportLabels">Market Of Sale</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="marketOfSale"
                  onChange={handleCheckbox}
                  checked={data.marketOfSale}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="MOSComponentDetails">
            <Col sm="5" md="5">
               <span className="reportLabels">Market of Sale Components</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="MOSComponentDetails"
                  onChange={handleCheckbox}
                  checked={data.MOSComponentDetails}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="materialsAndComposition">
            <Col sm="5" md="5">
               <span className="reportLabels">Materials And Composition</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="materialsAndComposition"
                  onChange={handleCheckbox}
                  checked={data.materialsAndComposition}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="mepSepCertifications">
            <Col sm="5" md="5">
               <span className="reportLabels">MEP-SEP Certifications</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="mepSepCertifications"
                  onChange={handleCheckbox}
                  checked={data.mepSepCertifications}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="mepSepCompEqts">
            <Col sm="5" md="5">
               <span className="reportLabels">MEP-SEP Component Equivalents</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="mepSepCompEqts"
                  onChange={handleCheckbox}
                  checked={data.mepSepCompEqts}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="notes">
            <Col sm="5" md="5">
               <span className="reportLabels">Notes</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="notes"
                  onChange={handleCheckbox}
                  checked={data.notes}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="partCertifications">
            <Col sm="5" md="5">
               <span className="reportLabels">Part Certifications</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="partCertifications"
                  onChange={handleCheckbox}
                  checked={data.partCertifications}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="partComponentEquivalents">
            <Col sm="5" md="5">
               <span className="reportLabels">Part Component Equivalents</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="partComponentEquivalents"
                  id="partComponentEquivalents_1"
                  onChange={handleCheckbox}
                  checked={data.partComponentEquivalents}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="performanceCharacteristics">
            <Col sm="5" md="5">
               <span className="reportLabels">Performance Characteristics</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="performanceCharacteristics"
                  onChange={handleCheckbox}
                  checked={data.performanceCharacteristics}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="plants">
            <Col sm="5" md="5">
               <span className="reportLabels">Plants</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="plants"
                  onChange={handleCheckbox}
                  checked={data.plants}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="producingFormula">
            <Col sm="5" md="5">
               <span className="reportLabels">Producing Formula</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="producingFormula"
                  onChange={handleCheckbox}
                  checked={data.producingFormula}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="sapBomAsFed">
            <Col sm="5" md="5">
               <span className="reportLabels">SAP BOM As Fed</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="sapBomAsFed"
                  onChange={handleCheckbox}
                  checked={data.sapBomAsFed}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="specsAndDocs">
            <Col sm="5" md="5">
               <span className="reportLabels">Specs and Docs</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="specsAndDocs"
                  onChange={handleCheckbox}
                  checked={data.specsAndDocs}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="stabilityDocument">
            <Col sm="5" md="5">
               <span className="reportLabels">Stability Document</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="stabilityDocument"
                  onChange={handleCheckbox}
                  checked={data.stabilityDocument}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pgDSMSubstitutePartsIn">
            <Col sm="5" md="5">
               <span className="reportLabels">Substitute Parts In</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMSubstitutePartsIn"
                  onChange={handleCheckbox}
                  checked={data.pgDSMSubstitutePartsIn}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pgDSMSustainability">
            <Col sm="5" md="5">
               <span className="reportLabels">Sustainability</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="pgDSMSustainability"
                  onChange={handleCheckbox}
                  checked={data.pgDSMSustainability}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="weightsAndDimensions">
            <Col sm="5" md="5">
               <span className="reportLabels">Weights and Dimensions</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="weightsAndDimensions"
                  onChange={handleCheckbox}
                  checked={data.weightsAndDimensions}
               />
            </Col>
         </Row>
         
         
         <Row className="mb-3" id="partAndSpecFormlabel">
            <Col sm="11" md="11">
               <span className="reportLabels">
                  Please enter Part name(s) and/or Change Action(s) below <b>OR</b> upload a
                  .txt file containing Part Name(s) and/or Change Action(s).
               </span>
            </Col>
         </Row>
         <Row className="mb-3" id="partAndSpecFormPart">
            <Col sm="5" md="5">
               <span className="reportLabels" id="impInput">Part Name</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Control
                  as="textarea"
                  name="partName"
                  value={data.partName}
                  rows={3}
                  onChange={handleTextChange}
                  className={`${blinkSearch}`}
                  style={{ minHeight: "3rem" }}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="partAndSpecChangeAction">
            <Col sm="5" md="5">
               <span className="reportLabels" id="impInput">Change Action</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Control
                  as="textarea"
                  name="changeAction"
                  value={data.changeAction}
                  rows={3}
                  onChange={handleTextChange}
                  className={`${blinkSearch}`}
                  style={{ minHeight: "3rem" }}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="partAndSpecInput">
            <Col sm="5" md="5">
               <span className="reportLabels" id="impInput">Input File(ANSI .txt files only)</span>
            </Col>
            <Col sm="6" md="6">
               <input type="file" id="file" onChange={fileValidation} />
               <Button variant="primary" onClick={handleClearFile}>
                  Clear
               </Button>
            </Col>
         </Row>
         <Row className="mb-3" id="partAndSpecCustomnName">
            <Col sm="5" md="5">
               <span className="reportLabels">Report Custom Name</span>
            </Col>
            <Col sm="6" md="6" mt="2">
               <Form.Control
                  as="input"
                  name="reportCustomName"
                  value={data.reportCustomName}
                  rows={3}
                  className="reportOptions"
                  onChange={handleTextChange}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="partAndSpecTemplate">
            <Col sm="5" md="5">
               <span className="reportLabels">Save as Template (New Template will be created)</span>
            </Col>
            <Col sm="6" md="6" mt="2">
               <Form.Control
                  as="input"
                  name="template"
                  value={data.template}
                  rows={3}
                  className="reportOptions"
                  onChange={handleTextChange}
               />
            </Col>
         </Row>
         <Row>
            <Col md="11" sm="11" align="center">
               <p
                  style={{ marginTop: "4px", fontWeight: "bold" }}
                  className={success ? "successMsg" : "alertMsg"}
               >
                  {alertMessage}
               </p>
            </Col>
         </Row>
         <br />
         <ReportSubmit
            data={data}
            handleClearItems={handleClearItems}
            handler={handleValidation}
            tabSize={selectedCheckboxes.size === 0 ? -1 : selectedCheckboxes.size}
            clearMsg={clearMsg}
         />
         <br />
      </React.Fragment>
   )
}
export default PartAndSpec